var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.status)?_c('InternalFundingStatus',{attrs:{"status":_vm.status}}):_c('span',[_vm._v(_vm._s(_vm.fallBackValue))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }